<script setup>
import { ref, computed, onMounted } from 'vue';
import { Link, usePage } from '@inertiajs/vue3';
import DropdownItem from '@/Components/DropdownItem.vue';
import DarkSwitch from '../DarkSwitch.vue';

const showMobileNav = ref(false);

const emit = defineEmits(['close-mobile-nav']);
const page = usePage();

const props = defineProps({
  user: Object,
  menuItems: {
    type: Array,
    required: false
  }
});

// Trial status computeds
const trialData = computed(() => page.props.trialData || {});
const isSubscribed = computed(() => page.props.subscribed?.user || false);
const showTrialStatus = computed(() => trialData.value?.hasActiveTrial && trialData.value?.remainingDays > 0);
const remainingDays = computed(() => trialData.value?.remainingDays || 0);

function closeNav() {
  emit('close-mobile-nav');
}

onMounted(() => {
  if (showTrialStatus.value) {
    console.log('MobileNav - Showing trial status:', remainingDays.value, 'days remaining');
  } else {
    console.log('MobileNav - No trial, isSubscribed:', isSubscribed.value);
  }
});
</script>

<template>
  <transition name="slide">
    <div v-show="showMobileNav" id="navbarSupportedContent"
      class="fixed right-0 top-0 z-50 h-full w-full bg-[#130518] p-4 opacity-95 md:w-1/2" style="z-index: 99999">
      <button @click="closeNav" class="absolute text-2xl text-white right-4 top-4">
        <i class="text-gray-400 fa-regular fa-circle-xmark"></i>
      </button>
      <ul class="flex flex-col items-center gap-4 mt-20 text-white">
        <!-- Trial Status Display -->
        <div v-if="showTrialStatus" class="w-full text-center">
          <div class="flex flex-col items-center gap-2 px-4 py-3 mb-4 border border-orange-500 rounded-lg bg-orange-500/10">
            <div class="flex items-center gap-2">
              <i class="text-orange-400 fas fa-clock"></i>
              <span class="text-sm font-medium text-orange-200">
                {{ remainingDays }} Trial Days Left
              </span>
            </div>
            <a :href="route('subscribe')" 
               class="px-4 py-2 text-xs font-medium text-white transition-colors rounded-md bg-primary hover:bg-purple-800"
               @click="closeNav">
              Upgrade Now
            </a>
          </div>
        </div>
        
        <!-- Regular upgrade button for non-trial users -->
        <a v-else-if="!isSubscribed" :href="route('subscribe')"
          class="w-full !text-white hover:!text-white flex justify-center items-center"
          @click="closeNav">
          UPGRADE NOW
        </a>

        <div class="flex flex-col items-center gap-4 mt-20 text-white">
          <div v-for="(item, index) in menuItems" :key="index">
            <DropdownItem v-if="item.routeName" :href="route(item.routeName)"
              class="w-full !text-white hover:!text-white">
              {{ item.text }}
            </DropdownItem>

            <DropdownItem v-else-if="item.href && !item.isButton" :href="item.href"
              class="w-full !text-white hover:!text-white">
              {{ item.text }}
            </DropdownItem>
          </div>
          <Link href="/logout" method="post" as="button"
            class="flex items-center gap-3 tracking-wide text-white hover:text-white hover:underline">
          <i class="fas fa-sign-out"></i>
          Logout
          </Link>
          <DarkSwitch class="mt-4 bg-blue-200" @click="closeNav" />
        </div>
      </ul>
    </div>
  </transition>
</template>
